import { useState } from "react";
import { Link } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import { SharedCard } from "../../components/shared";
import { MessagesDesk } from "../../components/messaging";
import { useAuth } from "../../js/hooks/useAuth";
import { postClientEmailOptIn } from "../../js/api/messaging/clients";
import { getById } from "../../js/db";

export default function ClientMessages() {
  const { session, role } = useAuth();
  const user = getById("users", session?.userId);
  const [optIn, setOptIn] = useState(Boolean(user?.email_report_opt_in));
  const [message, setMessage] = useState("");
  const portfolioPath = role === "seller" ? "/seller/home" : "/start";

  function toggleOptIn() {
    const next = !optIn;
    try {
      postClientEmailOptIn({ email_report_opt_in: next }, session);
      setOptIn(next);
      setMessage(
        next
          ? "You will receive archived communication reports by email."
          : "Report emails are turned off."
      );
    } catch (error) {
      setMessage(error.message);
    }
  }

  return (
    <AppLayout variant={role === "seller" ? "seller" : "public"}>
      <MessagesDesk deskRole="client">
        {message ? <p className="confirm-banner">{message}</p> : null}
        <SharedCard title="Communication reports" className="messages-optin">
          <label className="checkbox-item">
            <input type="checkbox" checked={optIn} onChange={toggleOptIn} />
            <span>Email me a copy of the communication report when this file is archived.</span>
          </label>
        </SharedCard>
        <p className="muted" style={{ marginTop: "1rem" }}>
          <Link to={portfolioPath}>{role === "seller" ? "Seller home" : "Continue buyer checklist"}</Link>
        </p>
      </MessagesDesk>
    </AppLayout>
  );
}
